'use strict';

var React = require('react'),
    Collection = require('../organisms/Collection'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    StampStore = require('../stores/StampStore'),
    getUniqueStampImages = require('../utils/getUniqueStampImages'),
    SidebarBody = require('../organisms/SidebarBody'),
    { PropTypes } = React;

var PinterestPicker = React.createClass({
  mixins: [PureRenderMixin, createStoreMixin(StampStore)],

  propTypes: {
    stampId: PropTypes.number.isRequired
  },

  getStateFromStores(props) {
    var stamp = StampStore.get(props.stampId),
        images = getUniqueStampImages(stamp);

    return {
      images: images
    };
  },

  render: function () {
    var stampId = this.props.stampId;

    return (
      <SidebarBody title='Choose an image to pin'>
        <Collection type='pinterestImages'
                    context='sidebar'
                    mode='grid'
                    columns={2}
                    itemProps={{ stampId: stampId }}
                    items={this.state.images} />
      </SidebarBody>
    );
  }
});

module.exports = PinterestPicker;



/** WEBPACK FOOTER **
 ** ./sidebar/PinterestPicker.jsx
 **/